var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:[( _obj = {}, _obj[("card-" + _vm.type)] = _vm.type, _obj )]},[(_vm.$slots.default)?_c('div',{staticClass:"card-body"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }